import React from "react";
import { graphql } from "gatsby";
import Header from "../components/en/headers/Header";

import ShopItemHeader from "../components/en/shop-items/ShopItemHeader";
import ShopItemDescription from "../components/en/shop-items/ShopItemDescription";
import CallToAction from "../components/en/layouts/CallToAction";
import Footer from "../components/en/layouts/Footer";
import NakedSEO from "../components/en/seo/NakedSeo";

function MineProductEn({
    data,
    pageContext: {
        title,
        description,
        additionalDescription,
        slug,
        imageDirectory,
    },
}) {
    return (
        <div>
            <NakedSEO
                title={`${title} - Shop and souvenirs`}
                description={description}
            />
            <Header />
            <ShopItemHeader title="Shop and souvenirs" />
            <ShopItemDescription
                title={title}
                description={description}
                additionalDescription={additionalDescription}
                imagesData={data.images.nodes}
            />
            <CallToAction />
            <Footer />
        </div>
    );
}

// This needs to be dynamic based on the slug passed in via context in gatsby-node.js
export const query = graphql`
    query($imagesRegex: String!) {
        images: allFile(
            sort: { fields: [base] }
            filter: { relativePath: { regex: $imagesRegex } }
        ) {
            nodes {
                childImageSharp {
                    gatsbyImageData(
                        width: 800
                        placeholder: BLURRED
                        formats: [AUTO, WEBP, AVIF]
                    )

                    fluid(quality: 100, maxWidth: 1920) {
                        ...GatsbyImageSharpFluid_withWebp
                    }
                }
            }
        }
    }
`;

export default MineProductEn;
